export default (contract: string | GQL.IContractDetails) => {
  if (typeof contract !== 'string' && contract?.descriptionProduct)
    return `(${contract.descriptionProduct})`;
};
